import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Card, Grid, Icon, Header} from 'semantic-ui-react';
import _ from 'lodash';

import {toTitleCase} from 'common/utils';

export class ListEpocOrganizations extends Component {
  sortOrgs(orgs) {
    return _.sortBy(orgs, [
      (o) => {
        return o.displayName || o.legalBusinessName;
      },
    ]);
  }

  displayOrgName(organization) {
    let name = organization.displayName || organization.legalBusinessName;
    return toTitleCase(name);
  }

  render() {
    let sortedOrgs = this.sortOrgs(this.props.organizations);
    return _.map(sortedOrgs, (organization, index) => (
      <Grid.Column width={this.props.columnWidth} key={index}>
        <Card fluid>
          <Card.Content>
            <Header as="h3">{this.displayOrgName(organization)}</Header>
          </Card.Content>
          <Card.Content textAlign="right">
            <Link
              to={`/organizationProfile/${organization.entityId}`}
              title={'Manage ' + this.displayOrgName(organization)}
            >
              Manage Organization >
            </Link>
          </Card.Content>
        </Card>
      </Grid.Column>
    ));
  }
}
export default ListEpocOrganizations;
